// Module
var code = "<react-component name=\"SmsDeliveriesReport\"></react-component>\n";
// Exports
module.exports = code;